
















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { readGroupChatRef, messagesRef } from '@/firebase'
import {
  GroupChatModel,
  MessageModel,
  UserModel,
  EUserStatus,
  IdName,
  EFileFormat,
  Mentionable,
} from '@/models'
//@ts-ignore
import _ from 'lodash'
import { triggerFavorite } from '@/helpers/GetNotificationCount'
import GroupChatService from '@/services/GroupChatService'
import { runDownload, downloadLabel, revokeObjectUrlLater } from '@/helpers/FileDownload'
import MessageService from '@/services/MessageService'
import moment from 'moment'
import ManageMemberGroupChat from '@/views/Chat/ManageMemberGroupChat/index.vue'
import GalleryModal from '@/views/Chat/GalleryModal/index.vue'
import store from '@/store'
import { getModule } from 'vuex-module-decorators'
import ModalShowProfile from '@/components/Modal/ModalShowProfile.vue'
import ModalFullImageViewer from '@/components/Modal/ModalFullImageViewer.vue'
import ChatService from '@/services/ChatService'
import CommonTopicVueX from '@/store/modules/CommonTopic'
import CheckDevice from '@/helpers/CheckDevice'
import ModalLikers, { ListLiker } from '@/components/Modal/ModalLikers.vue'
import { checkScript } from '@/validations/validation'
const CommonTopicModule = getModule(CommonTopicVueX, store)
import NavMenu from '@/components/NavMenu.vue'
import Header from '@/components/Header.vue'
import Banner from '@/components/Banner.vue'
import { EhumbNailsDisplay } from '@/models/Setting/Enum'
import CheckFileFormat from '@/helpers/CheckFileExtension'
import PreviewText from '@/helpers/PreviewText'
import linkifyHtml from "linkify-html";
import EmojiPopup from '@/components/EmojiPopup.vue'
import MentionSuggestDropdown from '@/components/MentionSuggestDropdown.vue'
//@ts-ignore
import _, { DebouncedFunc } from 'lodash'
import { MENTION_VALUE, allItemMention, allMentionCheckKeyword, calculateMentionPopup, releaseMentionPopup, getCaretTextBefore, getMentionIdsFromContent, handleDeleteSuggestion, handleInputToMention, handleSelectSuggestion, loadingItemMention, mentionRegex } from '@/helpers/Mentions'
//@ts-ignore
import At from 'vue-at'
import { decodeHtml, escapeHtml, getInlineEditorImageSrcFromClick, isChatSystemMessage, sanitizeContentEditableInput, extractContentFromContentEditableOrTiny, handleTranslation, getScrollableContainer, removeHTML, stripHtmlKeepFormat, insertMention, ensureRange, getRange, applyRange, getAtAndIndex, getPrecedingRange, getEmojiByNativeFunc } from '@/helpers/Common'
import { ERR_API_KEY, TRANSLATION_TYPE } from '@/constants'
import InputSearchMention from '@/components/InputSearchMention.vue'
import SearchMentionBox from '@/components/SearchMentionBox.vue'
import { MAX_USER_DISPLAY } from '@/constants'
import { mappingChatMessage } from '@/helpers/Chat'
// @ts-ignore
import { Emoji, EmojiIndex } from 'emoji-mart-vue-fast'
// @ts-ignore
import data from 'emoji-mart-vue-fast/data/apple.json'
import { groupchatRef } from '@/firebase'

if (At.methods?.insertHtml) {
  At.methods.insertHtml = function(html: any, r: Range) {
    r.deleteContents()

    // Clean up the leftover trigger text (like "@")
    if (r.startContainer.nodeType === Node.TEXT_NODE) {
      const node = r.startContainer as Text
      if (!node.nodeValue || /^@/.test(node.nodeValue)) {
        node?.remove()
      }
    }

    // Create the mention wrapper
    const newElement = document.createElement('span')
    newElement.dataset.atEmbedded = ''
    newElement.setAttribute('contenteditable', 'false')

    // Add spaces before and after mention (same as original vue-at)
    newElement.appendChild(document.createTextNode(' '))
    newElement.appendChild(this.htmlToElement(html))
    newElement.appendChild(document.createTextNode(' '))

    // Insert mention into the range
    r.insertNode(newElement)

    // Add an empty text node separator after the mention
    // → prevents backspace from deleting multiple mentions at once
    const separator = document.createTextNode(' ')
    if (newElement.parentNode) {
      newElement.parentNode.insertBefore(separator, newElement.nextSibling)
    }

    // Place caret after the separator
    r.setStartAfter(separator)
    r.collapse(true)

    applyRange(r)
  }
}

// Resolves the node adjacent to the caret that should be considered for
// embedded-mention deletion. Returns null when the caller must bail out
// (no node, or a non-whitespace text node sitting before the caret).
function resolveAdjacentNodeForEmbeddedDelete(range: Range): any | null {
  let a: any =
    range.endContainer.childNodes[range.endOffset] ||
    range.endContainer.childNodes[range.endOffset - 1]

  if (!a || (a.nodeType === Node.TEXT_NODE && !/^\s?$/.test(a.data))) {
    return null
  }

  if (a.nodeType === Node.TEXT_NODE) {
    if (a.previousSibling) a = a.previousSibling
  } else if (a.previousElementSibling) {
    a = a.previousElementSibling
  }

  return a
}

// Finds the last embedded mention node inside (or equal to) the given node.
function findLastEmbeddedMention(a: any): any | undefined {
  let ch: any[] = Array.prototype.slice.call(a.childNodes)
  ch = Array.prototype.reverse.call(ch)
  ch.unshift(a)

  let last: any
  Array.prototype.some.call(ch, (c: any) => {
    if (c.getAttribute && c.dataset.atEmbedded != null) {
      last = c
      return true
    }
    return false
  })
  return last
}

// Deletes everything from the start of `node` to the caret and reports the edit.
function deleteFromNodeAndNotifyInput(node: any, ctx: any) {
  const r = getRange()
  if (!r) return
  r.setStartBefore(node)
  r.deleteContents()
  applyRange(r)
  ctx.handleInput()
}

// Sets the caret at offset 0 inside an empty `div` (which was just reset to `<br>`).
function placeCaretAtDivStart(div: HTMLDivElement, editable: HTMLElement, ctx: any) {
  div.innerHTML = '<br>'

  if (CheckDevice.isMobile()) {
    editable.focus()
  }

  const range = document.createRange()
  range.setStart(div, 0) // caret ngay trong div
  range.collapse(true)

  const sel = globalThis.getSelection()
  sel?.removeAllRanges()
  sel?.addRange(range)
  ctx.handleInput()
}

// Re-normalizes the editable: resets any empty `<div>` to `<br>`,
// re-focuses (important on mobile) and parks the caret at the end.
function normalizeEditableAfterEmbeddedDelete(editable: HTMLElement, ctx: any) {
  editable.querySelectorAll('div').forEach((div: HTMLDivElement) => {
    if (!div.textContent?.trim() && div.children.length === 0) {
      placeCaretAtDivStart(div, editable, ctx)
    }
  })

  // ép focus lại (đặc biệt cần trên mobile)
  editable.focus()

  // đặt caret cuối
  const range = document.createRange()
  range.selectNodeContents(editable)
  range.collapse(false)

  const sel = globalThis.getSelection()
  sel?.removeAllRanges()
  sel?.addRange(range)

  ctx.handleInput()
}

// Handles backspace when the caret sits next to a custom embedded mention.
function handleCustomEmbeddedDelete(e: any, range: Range, ctx: any) {
  const adjacent = resolveAdjacentNodeForEmbeddedDelete(range)
  if (!adjacent) return

  const last = findLastEmbeddedMention(adjacent)
  if (!last) return

  e.preventDefault()
  e.stopPropagation()
  deleteFromNodeAndNotifyInput(last, ctx)

  const editable = ctx.$el.querySelector(
    '[contenteditable="true"]'
  ) as HTMLElement | null

  if (editable) {
    normalizeEditableAfterEmbeddedDelete(editable, ctx)
  }
}

// Handles backspace when the caret sits inside a partially-typed member mention.
function handleMemberMentionDelete(e: any, range: Range, ctx: any) {
  const { atItems, members, suffix, deleteMatch, itemName } = ctx
  const text = range.toString()
  const { at, index } = getAtAndIndex(text, atItems)
  if (index <= -1) return

  const chunk = text.slice(index + at.length)
  const hasMatch = members.some((v: any) => deleteMatch(itemName(v), chunk, suffix))
  if (!hasMatch) return

  e.preventDefault()
  e.stopPropagation()
  const r = getRange()
  if (!r) return
  r.setStart(r.endContainer, index)
  r.deleteContents()
  applyRange(r)
  ctx.handleInput()
}

if (At.methods?.handleDelete) {
  At.methods.handleDelete = function(e: any) {
    const range = getPrecedingRange()
    if (!range) return

    if (this.customsEmbedded && range.endOffset >= 1) {
      handleCustomEmbeddedDelete(e, range, this)
      return
    }

    handleMemberMentionDelete(e, range, this)
  }
}

@Component({
  components: {
    ManageMemberGroupChat,
    GalleryModal,
    ModalShowProfile,
    ModalFullImageViewer,
    ModalLikers,
    NavMenu,
    Header,
    Banner,
    EmojiPopup,
    MentionSuggestDropdown,
    At,
    SearchMentionBox,
    InputSearchMention,
    Emoji
  }
})
export default class Chat extends Vue {
  userId: number = -1
  currentUser: UserModel = new UserModel()
  groupChatSelected: GroupChatModel = new GroupChatModel()
  unreadMeesageStartId: number = 0
  unreadMeesageEndId: number = 0
  groupItemSelected?: number
  groupSelected?: IdName
  private lstMessageGroupChatDefault: any[] = []
  lstMessageGroupChat: MessageModel[] = []
  private fileUpload: any = null
  fileUploadTemp: any = null
  messageReply: MessageModel = new MessageModel()
  lstFileUpload: any[] = []
  isVisableReplyMessage: boolean = false
  isVisiableLstUploadFile: boolean = false
  loadingLstMessage: boolean = true
  showNoMessage: boolean = false
  getTinyConfig: any = {}
  editorData: string = ''
  private messageSpecial: boolean = false
  openGallery: boolean = false
  showModalManageMember: boolean = false
  infoMess: string = ''
  isMultipleChatGroup = false
  public noAvatar = require('@/assets/images/avatar-default.png')
  lstUserGroupChat: any[] = []

  errorMess: string = ''
  canOpenFullImageModal: boolean = false
  fullOverviewSrc: string = ''

  //API hepler
  page: number = 1
  lastPage: number = 1
  private searchPage: number = 1
  private pageUp: number = 1
  private pageDown: number = 1
  private isPageUp: boolean = false
  private isPageDown: boolean = false
  loadMoreDown: boolean = false
  disablePageUp: boolean = false
  disablePageDown: boolean = false
  private limitMessage: number = 10 //this.$store.state.setting.setting.setting_display.number_item_lists

  findMessagePage = -1
  messFound = false

  confirmLeaveChatMess: string = ''

  //
  private checkUserSendMessage: boolean = false
  idGroupChat: number = Number(this.$route.params.groupChatId)
  groupChatName: string = ''
  eUserStatus = EUserStatus
  contentTextArea: string = ''
  chatBoxNameColor: string = this.$store.state.setting.setting
    .setting_themes.theme.title_color
  //validate
  private imageType: string[] = [
    'image/png',
    'image/gif',
    'image/jpeg',
    'image/jpg'
  ]
  maxFileSize: any = {
    mb: 25,
    bytes: 25 * 1048576
  }
  groupChatOver200: boolean = false
  overLengthContent: boolean = false
  includesScriptTagContent: boolean = false
  showFooter: boolean = true
  isMobile: boolean = false
  isSafariIos: boolean = false
  private screenLoading: boolean = true
  private firstLoad: boolean = true
  showButtonScrollToBottom: boolean = false

  //
  private fileIds: number[] = []
  private LEAVE_GROUP_CHAT: string = 'LEAVE_GROUP_CHAT'
  private LEAVE_SYSTEM: string = 'LEAVE_SYSTEM'
  bannerShowOff: boolean = false
  mentionValue: any = MENTION_VALUE

  //modal helper
  modalMess: string = ''
  modalAction: any = () => {}
  isOverLength: boolean = false
  isIncludesScriptTag: boolean = false
  includesScriptTagMess: string = this.$t('common.form.no_script_tag', {
    name: this.$t('common.form.document') as string
  }) as string
  overLengthMess: string = this.$t('common.form.max_length', {
    name: this.$t('common.form.document') as string,
    length: 20000
  }) as string
  avatarDefault = require('@/assets/images/avatar-default.png')
  private deleteMess: any
  blinkMessageId: number = -1
  maxUserDisplay: number = MAX_USER_DISPLAY
  userListModal: ListLiker[] = []
  userListModalShowEmoji: boolean = false
  private confirmChange: any = () => {}
  displayThumbnail: boolean =
    this.$store.state.setting.setting.setting_display.display_image_video ===
    EhumbNailsDisplay.DISPLAY_THUMBNAILS
  eFileFormat = EFileFormat
  private unsubscribe: any = () => {}
  private readUnsubscribe: any = () => {}

  // editor mentions
  suggestionList: any[] = []
  suggestionListOutsideEditor: any[] = []
  showSuggestion: boolean = false
  private editorInstance: any
  private debouncedFetchMention: DebouncedFunc<(event: any) => void>
  private debouncedFetchOutsideMention: DebouncedFunc<(event: any) => void>
  private preventFetchMention = false
  private preventTriggerFetchMention = false
  private isMentioning = false
  isLoading = false
  private failKeyword = ''
  private lastKeyword = ''
  listToSearchMentionWithBox: Mentionable[] = []
  listToSearchMentionWithBoxInModal: Mentionable[] = []
  listToSearchMentionDefault: Mentionable[] = []
  private savedRange: Range | null = null // use in current mode
  isLoadingMention: boolean = false
  isLoadingMentionInModal: boolean = false
  private isComposition = false

  public emojiIndex = new EmojiIndex(data)

  get atInstance() {
    return this.$refs.at as any
  }

  getMsgFileImage(msg: any) {
    return msg.file.filter((file: any) => ["jpg", "jpeg", "png", "gif"].includes(file?.file_extension?.toLowerCase()))
  }

  getMsgFileNotImage(msg: any) {
    return msg.file.filter((file: any) => !["jpg", "jpeg", "png", "gif"].includes(file?.file_extension?.toLowerCase()))
  }

  async created() {
    this.$bus.$on('refetchGroupChat', this.refetchGroupChat)
    this.init()
    this.debouncedFetchMention = _.debounce(
      this.handleSuggestionListEditor,
      500
    )
    this.debouncedFetchOutsideMention = _.debounce(
      this.handleSuggesionListOutsideEditor,
      500
    )
    await this.fetchUserInGroupChat()
  }

  onOpenSuggestionPopup(rect: any) {
    const mentionDropdownWrapper = this.$refs.mentionDropdownWrapper as Vue
    const suggestionDiv = mentionDropdownWrapper.$el as HTMLElement

    calculateMentionPopup({
      getRect: () => this.editorInstance.selection.getRng().getBoundingClientRect(),
      suggestionDiv,
      callback: () => {
        this.showSuggestion = true
      },
      isInModal: true,
      editorIframe: this.editorInstance.iframeElement
    })
  }

  onSelect({ event, suggestion }: any) {
    event.stopPropagation()
    this.isMentioning = true
    handleSelectSuggestion({
      suggestion,
      editorInstance: this.editorInstance,
      callback: () => {
        this.onClearSuggestionState()
      }
    })
  }

  onDelete(event: any) {
    handleDeleteSuggestion({
      event,
      editorInstance: this.editorInstance,
      callback: () => {
        this.onClearSuggestionState()
      }
    })
  }

  onClearSuggestionState() {
    // NWS-1773: 候補を閉じるタイミングで監視を解放する（積み上がりを防ぐ）
    releaseMentionPopup()
    this.suggestionList = []
    this.showSuggestion = false
    const mentionDropdownWrapper = this.$refs.mentionDropdownWrapper as Vue
    if (mentionDropdownWrapper && mentionDropdownWrapper.$el) {
      mentionDropdownWrapper.$el.scrollTop = 0
    }
  }

  closePanel() {
    if (this.atInstance) {
      this.atInstance.closePanel()
    }
  }

  onMention(keyword: string) {
    if (this.isMultipleChatGroup) {
      this.suggestionListOutsideEditor = []
      this.debouncedFetchOutsideMention(keyword)
    }
  }

  onInsertData() {
    this.preventFetchMention = true
    this.$nextTick(() => {
      // allow next input
      setTimeout(() => {
        this.preventFetchMention = false
      }, 500)
    })
  }

  async fetchMentionByGroupChatApi({
    keyword,
    shouldHandleLoading = false
  }: {
    keyword: string
    shouldHandleLoading?: boolean
    }) {
    if (shouldHandleLoading) {
      this.isLoadingMention = true
      this.isLoadingMentionInModal = true
    }

    try {
      const res = await GroupChatService.getMemberGroupChatList({
        groupChatId: this.$route.params.groupChatId,
        page: 1,
        limit: this.$store.state.setting.setting.setting_display
          .number_item_lists,
        mention: true,
        search: keyword
      })

      let mappingData = []
      if (res.status === 200) {
        // save last success keyword
        this.lastKeyword = keyword
        if (res.data.data.length > 0) {
          this.failKeyword = ''
          mappingData = res.data.data.map((item: any) => ({
            id: item.id,
            name: item.name,
            avatar: item?.user_profile?.avatar_small
          }))
        } else {
          this.failKeyword = keyword
        }
      }
      return mappingData
    } finally {
      setTimeout(() => {
        this.isLoadingMention = false
        this.isLoadingMentionInModal = false
      }, 500);
    }
  }

  async handleSuggestionListEditor(keyword: string) {
    const isDeleting = keyword.length < this.lastKeyword.length

    if (isDeleting) {
      this.failKeyword = ''
    }

    if (this.failKeyword && keyword.startsWith(this.failKeyword)) {
      return
    }
    
    const range = this.editorInstance.selection.getRng()
    const rect = range.getBoundingClientRect()

    this.suggestionList = []
    this.isLoading = true
    this.onOpenSuggestionPopup(rect)
    const startTime = Date.now()

    const response = await this.fetchMentionByGroupChatApi({
      keyword
    })

    const elapsed = Date.now() - startTime
    const delay = Math.max(0, 500 - elapsed)

    setTimeout(() => {
      this.isLoading = false
      if (response && response.length > 0) {
        this.suggestionList = response
      }

      // handle all mention
      if (!keyword || allMentionCheckKeyword.includes(keyword.toLowerCase())) {
        this.suggestionList.unshift(allItemMention)
      }
      
      if (!this.suggestionList.length) {
        this.onClearSuggestionState()
      }
    }, delay);
  }

  filterMatch(name: string, chunk: any, at: any) {
    if (name.startsWith('_FAKE_')) return true
    return name.toLowerCase().includes(chunk.toLowerCase())
  }

  async handleSuggesionListOutsideEditor(keyword: string) {
    const isDeleting = keyword.length < this.lastKeyword.length

    if (isDeleting) {
      this.failKeyword = ''
    }

    if (this.failKeyword && keyword.startsWith(this.failKeyword)) {
      return
    }

    if (!this.preventTriggerFetchMention) {
      this.suggestionListOutsideEditor = [] // clear all value
      this.suggestionListOutsideEditor.unshift(loadingItemMention) // start fake loading

      const startTime = Date.now()
      
      const response = await this.fetchMentionByGroupChatApi({
        keyword
      })

      const elapsed = Date.now() - startTime
      const delay = Math.max(0, 500 - elapsed)

      setTimeout(() => {
        this.suggestionListOutsideEditor.shift() // end fake loading

        if (response.length > 0) {
          this.suggestionListOutsideEditor = response
        }

        // handle all mention
        if (!keyword || allMentionCheckKeyword.includes(keyword.toLowerCase())) {
          this.suggestionListOutsideEditor.unshift(allItemMention)
        }
      }, delay);
    }

    if (this.preventTriggerFetchMention) {
      this.preventTriggerFetchMention = false
    }
  }

  private lastPixelRatio = window.devicePixelRatio;

  private onResize = () => {
    const currentRatio = window.devicePixelRatio;
    if (currentRatio === this.lastPixelRatio) {
      console.log('📐 Normal resize, ignore');
    } else {
      console.log('🔍 Zoom event detected');
      this.lastPixelRatio = currentRatio;
      this.forceLoadUntilScrollable();
    }
  };

  private onWindowScroll = () => {
    const reachBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight
    if (reachBottom && !this.$route.query.message) {
      this.scrollToBottom(false)
    }
    this.closePanel();
  };
  
  private onListMessageScroll = () => {
    const lstMsgScroll = this.$refs.lstMessageGroup as any;
    const reachBottom = lstMsgScroll.scrollTop + lstMsgScroll.clientHeight === lstMsgScroll.scrollHeight;
    if (reachBottom) {
      this.scrollToBottom(false)
    }
  };

  async mounted() {
    await Promise.all([
      this.getInfoGroupChat(),
      this.getAllLstMessageInGroupChat(),
      this.fetchUserInGroupChat()
    ])

    if (this.isMultipleChatGroup) {
      const result = await this.fetchMentionByGroupChatApi({
        keyword: ''
      })
      this.listToSearchMentionDefault = [allItemMention, ...result]
      this.listToSearchMentionWithBox = [...this.listToSearchMentionDefault]
      this.listToSearchMentionWithBoxInModal = [...this.listToSearchMentionDefault]
    }

    this.forceLoadUntilScrollable();

    window.addEventListener('resize', this.onResize);
    
    window.addEventListener('scroll', this.onWindowScroll, true);

   (this.$refs.lstMessageGroup as any)?.addEventListener('scroll', this.onListMessageScroll);

    if (this.atInstance) {
      const editorEl = this.atInstance.$el.querySelector('.mention-contenteditable')
      if (editorEl) {
        editorEl.addEventListener('input', this.onContentEditableInput)
        editorEl.addEventListener('focusout', this.onContentEditableFocusOut)
        editorEl.addEventListener('focusin', this.onContentEditableFocusIn)
        editorEl.addEventListener('keyup', this.onContentEditableKeyUp)
      }
    }
  }

  beforeDestroy() {
    // NWS-1773: 画面破棄時にも取り残しが無いようにする
    releaseMentionPopup()
    this.$bus.$off('refetchGroupChat', this.refetchGroupChat)
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onWindowScroll, true);
    (this.$refs.lstMessageGroup as any)?.removeEventListener('scroll', this.onListMessageScroll);

    if (this.atInstance) {
      const editorEl = this.atInstance.$el.querySelector('.mention-contenteditable')
      if (editorEl) {
        editorEl.removeEventListener('input', this.onContentEditableInput)
        editorEl.removeEventListener('focusout', this.onContentEditableFocusOut)
        editorEl.removeEventListener('focusin', this.onContentEditableFocusIn)
        editorEl.removeEventListener('keyup', this.onContentEditableKeyUp)
      }
    }
  }

  destroyed() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }

    if (this.readUnsubscribe) {
      this.readUnsubscribe()
    }
  }

  isDisabledTranslate(msg: MessageModel) {
    return isChatSystemMessage(msg.content) || (!msg.is_html_content && msg.file.length);
  }

  async init() {
    this.reset()
    this.checkBannerShowOff()
    this.checkMobile()
    this.setUserLogin(this.userLogin)
    if (!this.currentUser.userId) return
    if (this.$route.params && this.$route.params.groupChatId) {
      this.groupItemSelected = Number(this.$route.params.groupChatId)
    }

    //init text editor
    this.initTextEditor()

    //init firebase to handle realtime
    this.handleRealtime()

    this.handleReadRealtime()

    //mark read group
    await this.markReadGroupChat()
  }

  reset() {
    this.unsubscribe()
    this.readUnsubscribe()
    this.idGroupChat = Number(this.$route.params.groupChatId)
    this.lstMessageGroupChatDefault = []
    this.lstMessageGroupChat = []
    this.page = 1
    this.lastPage = 1
    this.searchPage = 1
    this.pageUp = 1
    this.pageDown = 1
    this.isPageUp = false
    this.isPageDown = false
    this.loadMoreDown = false
    this.disablePageUp = false
    this.disablePageDown = false
  }

  async forceLoadUntilScrollable() {
    const el = this.$refs.lstMessageGroup as any;
    
    if (!el) return;

    let scrollContainer = getScrollableContainer(el);
    let attempts = 0;
    const maxAttempts = 1;

    while (scrollContainer.scrollHeight <= scrollContainer.clientHeight && attempts < maxAttempts && this.page < this.lastPage) {
      await this.clickLoadMoreMessage();
      attempts++;
    }
  }

  @Watch('editorData')
  watchEditorData() {
    const text = removeHTML(this.editorData)
    this.isOverLength =
      new Blob([text]).size > 80000 || _.toArray(text).length > 20000
    this.isIncludesScriptTag = checkScript(removeHTML(this.editorData))
  }

  refetchGroupChat() {
    this.page = 1
    this.fetchMessagesByGroupChatId()
  }

  /**
   * beforeRouteLeave
   */
  beforeRouteLeave(to: any, from: any, next: any) {
    this.markReadGroupChat()

    let msgInput: string = this.editorData
      ? this.editorData
      : // : (this.$refs.inputMessageChat as any).innerText
        this.contentTextArea

    //this case for modal search header
    if (document.querySelectorAll('#modal-search-header').length) {
      next()

      //normal case
    } else if (msgInput.trim().length) {
      this.confirmChange = next
      this.$bvModal.show('modal-confirm-unsave-leave')
    } else {
      next()
    }
  }

  confirm() {
    this.confirmChange()
  }

  checkBannerShowOff() {
    this.bannerShowOff =
      this.$store.state.setting.setting.setting_themes.theme
        .banner_header_bg_color ||
      this.$store.state.setting.setting.setting_themes.theme
        .banner_header_bg_img
  }

  checkMobile() {
    this.isMobile = CheckDevice.isMobile()
    this.isSafariIos = CheckDevice.iOSBrowerName() === CheckDevice.safari
  }

  async findMessageByNo(messageReply: any) {
    const isMessageExistInList = this.lstMessageGroupChat.find(item => item.messageId === messageReply.messageId)

    if (isMessageExistInList) {
      this.scrollToEl(messageReply)
      return
    }

    this.resetPage()
    await this.$router
      .replace({ query: { message: messageReply.messageId } })
      .catch(() => {})
    this.lstMessageGroupChatDefault = []
    this.lstMessageGroupChat = []
    this.getAllLstMessageInGroupChat()
  }

  resetPage() {
    this.page = 1
    this.lastPage = 1
    this.searchPage = 1
    this.pageUp = 1
    this.pageDown = 1
    this.isPageUp = false
    this.isPageDown = false
    this.loadMoreDown = false
    this.disablePageUp = false
    this.disablePageDown = false
  }

  @Watch('lstFileUpload')
  showFileUpload() {
    this.isVisiableLstUploadFile = !!this.lstFileUpload.length
  }

  @Watch('groupChatName')
  groupChatNameOnChange() {
    this.groupChatOver200 = !(
      new Blob([this.groupChatName]).size <= 255 * 4 &&
      _.toArray(this.groupChatName).length <= 255
    )
  }

  chatBoxNameFocus() {
    const chatBox: any = this.$refs.chatBoxName
    chatBox.focus()
    chatBox.classList.value = 'form-control p-0'
    this.chatBoxNameColor = '#000'
  }

  chatBoxNameBlur() {
    const chatBox: any = this.$refs.chatBoxName
    chatBox.classList.value = 'form-control border-0 bg-none p-0'
    this.chatBoxNameColor = this.$store.state.setting.setting.setting_themes.theme.title_color

    //validate
    if (!this.groupChatName || this.groupChatOver200) {
      this.groupChatName = this.groupChatSelected.gCName
      return
    }

    this.$blockui.show()
    GroupChatService.updateGroupChatName(
      this.$route.params.groupChatId,
      this.groupChatName
    ).finally(() => {
      this.$blockui.hide(false)
      chatBox.blur()
    })
  }

  handleMentionInput() {
    if (this.preventFetchMention) {
      this.preventFetchMention = false
      return
    }

    this.showSuggestion = false

    this.runMentionCheck(this.editorInstance)
  }

  private runMentionCheck(editor: any) {
    handleInputToMention({
      editorInstance: editor,
      errorCallback: this.onMentionError,
      successCallback: this.onMentionSuccess
    })
  }

  private onMentionError = () => {
    this.debouncedFetchMention.cancel()
    this.onClearSuggestionState()
  }

  private onMentionSuccess = (keyword: string) => {
    this.debouncedFetchMention(keyword)
  }

  private onEditorFocusIn(editor: any) {
    if (!this.isMultipleChatGroup) return
    requestAnimationFrame(() => this.runMentionCheck(editor))
  }

  /**
   * init text editor
   */
  initTextEditor() {
    // set key editor
    this.getTinyConfig = {
      language: this.$store.state.setting.setting.setting_language.code,
      height: 500,
      setup: (editor: any) => {
        this.editorInstance = editor
        editor.ui.registry.addContextToolbar('textselection', {
          predicate: (node: any) => {
            return !editor.selection.isCollapsed()
          },
          items: 'bold italic | quicklink h1 h2 h3 blockquote',
          position: 'selection',
          scope: 'node'
        })
        editor.on('keydown', (e: any) => {
          if (this.isMultipleChatGroup) {
            if (e.key === 'Backspace') {
              this.onDelete(e)
            }

            if (e.key === 'Escape') {
              this.preventFetchMention = true
              this.onClearSuggestionState()
            }
          }
        })
        editor.on('compositionstart', () => {
          this.isComposition = true
        })
        editor.on('compositionend', () => {
          this.isComposition = false
          this.handleMentionInput()
        })
        editor.on('keyup', (e: any) => {
          if (!this.isMultipleChatGroup  || this.isComposition) return

          this.handleMentionInput()
        })
        editor.on('focusin', () => this.onEditorFocusIn(editor))
        editor.on('blur', () => {
          this.failKeyword = ''
          setTimeout(() => {
            if (this.isMultipleChatGroup && !this.isMentioning) {
              this.onClearSuggestionState()
            }
          }, 100)
        })
        editor.on('click', (event: any) => {
          if (this.isMultipleChatGroup) {
            const target = event.target as HTMLElement
            const mentionDropdownWrapper = this.$refs
              .mentionDropdownWrapper as Vue
            const suggestionDropdown = mentionDropdownWrapper.$el as HTMLElement

            if (suggestionDropdown && !suggestionDropdown.contains(target)) {
              this.onClearSuggestionState()
            }
          }
        })
      },
      content_style: `
        p, h1, h2, h3, h4, h5, h6, blockquote, ul, ol {
          margin: 0;
        }
        code {
          background-color: #FAFAFA !important;
          padding: 8px !important;
          color: #0D47A1 !important;
        }
      `,
      selector: 'textarea#full-featured',
      formats: {
        blockquote: {
          block: 'blockquote',
          classes: 'tiny-editor-blockquote'
        }
      },
      deprecation_warnings: false,
      nonbreaking_force_tab: true,
      toolbar_mode: 'wrap',
      menubar: true,
      entity_encoding: 'raw',
      default_link_target: '_blank',
      plugins: [
        'advlist emoticons hr image media link lists nonbreaking preview searchreplace table blockquote'
      ],
      toolbar: [
        'fontsizeselect | fontselect | formatselect | undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | emoticons preview | image media link | searchreplace hr nonbreaking | table | blockquote'
      ],
      contextmenu: false,
      quickbars_insert_toolbar: false,
      image_dimensions: false,
      font_formats: `
        Andale Mono=andale mono,monospace;
        Arial=arial,helvetica,sans-serif;
        Arial Black=arial black,sans-serif;
        Book Antiqua=book antiqua,palatino,serif;
        Comic Sans MS=comic sans ms,sans-serif;
        Courier New=courier new,courier,monospace;
        Georgia=georgia,palatino,serif;
        Helvetica=helvetica,arial,sans-serif;
        Impact=impact,sans-serif;
        Symbol=symbol;
        Tahoma=tahoma,arial,helvetica,sans-serif;
        Terminal=terminal,monaco,monospace;
        Times New Roman=times new roman,times,serif;
        Trebuchet MS=trebuchet ms,geneva,sans-serif;
        Verdana=verdana,geneva,sans-serif
      `,
      file_picker_callback: (cb: any, value: any, meta: any) => {
        let input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.setAttribute('accept', 'image/*')

        document.body.appendChild(input)

        input.onchange = (event: any) => {
          const files: File[] = event.target.files || event.dataTransfer.files
          if (!files.length) return
          if (
            files[0].size < this.maxFileSize.bytes &&
            this.imageType.includes(files[0].type)
          ) {
            let formData = new FormData()
            formData.set('files[0]', files[0])
            formData.set('group_chat_id', String(this.idGroupChat))
            this.$blockui.show()
            GroupChatService.uploadFileByTiny(formData)
              .then(res => {
                if (res.status === 200) {
                  cb(res.data.image_paths[0], { title: files[0].name })
                }
              })
              .catch(err => {
                //@ts-ignore
                tinymce.activeEditor.undoManager.undo()
              })
              .finally(() => this.$blockui.hide(false))
          } else {
            this.$bvModal.show('modal-error-text-editor')
          }
          input.remove()
        }
        input.click()
      },
      images_upload_handler: (blobInfo: any, success: any, failure: any) => {
        if (
          blobInfo.blob().size < this.maxFileSize.bytes &&
          this.imageType.includes(blobInfo.blob().type)
        ) {
          let formData = new FormData()
          formData.set('files[0]', blobInfo.blob())
          formData.set('group_chat_id', String(this.idGroupChat))
          this.$blockui.show()
          GroupChatService.uploadFileByTiny(formData)
            .then(res => {
              if (res.status === 200) {
                success(res.data.image_paths[0])
              }
            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => this.$blockui.hide(false))
        } else {
          failure(
            this.$t('common.form.img_modified_with_max', {
              max: this.maxFileSize.mb
            })
          )
          //@ts-ignore
          tinymce.activeEditor.undoManager.undo()
        }
      }
    }
  }

  get userLogin() {
    return this.$store.state.userInfo.user
  }

  handleFileUpload(event: any) {
    const files: File[] = event.target.files || event.dataTransfer.files
    if (!files.length) return
    this.fileUpload = Array.from(files)
    this.uploadFileMsg()
  }

  async uploadFileMsg() {
    let file_ids: number[] = []
    let formData = new FormData()
    formData.set('group_chat_id', this.idGroupChat.toString())
    if (this.isVisableReplyMessage && this.messageReply) {
      formData.set('reply_message', this.messageReply.messageId.toString())
    }
    this.fileUpload.forEach((file: File) => {
      formData.append('files[]', file)
    })
    let errorTiny: boolean = false
    this.$blockui.show()
    await GroupChatService.uploadFileByTiny(formData)
      .then(res => {
        if (res.status === 200) {
          file_ids = res.data.file_ids
        }
      })
      .catch(err => {
        errorTiny = true
        if (err.response.status === 422) {
          if (err.response.data.message === ERR_API_KEY.MAX_TOTAL_FILE_SIZE) {
            this.modalAction = () => {}
            this.modalMess = this.$t('common.message.upload_over_size', {
              max: 25
            }) as string
          } else {
            this.modalMess = this.$t('common.message.something_went_wrong').toString()
          }
        }

        this.$bvModal.show('modal-error-chat-detail')
      })
      .finally(() => this.$blockui.hide(false))


    this.fileUpload.forEach((file: File, index: number) => {
      const file_id = file_ids?.[index]?.toString()

      formData.append('file_ids[]', file_id)
    })



    if (this.fileUpload && !errorTiny) {
      GroupChatService.uploadFile(this.idGroupChat, formData)
        .then(res => {
          if (res.status === 200) {
            this.$nextTick(() => {
              let scrollHeight = (this.$refs.lstMessageGroup as any)
                ?.scrollHeight
              let lstMsgScroll = this.$refs.lstMessageGroup as any
              lstMsgScroll.scrollTop = scrollHeight
            })
            this.isVisableReplyMessage = false
            this.contentTextArea = ''
            this.lstFileUpload = []
          }
          this.fileUpload = null

          this.checkUserSendMessage = true
        })
        .catch(err => {
          if (err.response.status === 422) {
            if (err.response.data.message === ERR_API_KEY.USER_MAX_UPLOAD_SIZE_IN_CHAT) {
              this.modalMess = (this.$store.state.userInfo.user.info.name +
                this.$t('common.message.error_user_max_chat_size')) as string
              this.modalAction = () => {}
            } else {
              this.modalMess = this.$t('common.message.something_went_wrong').toString()
            }
            this.$bvModal.show('modal-error-chat-detail')
          }
        })
    }
  }

  async sendMsgByTiny() {
    if (this.editorData && !this.isOverLength && !this.isIncludesScriptTag) {
      this.messageSpecial = true
      await this.sendMessage(false)
      this.editorData = ''
    } else {
      this.messageSpecial = false
    }
  }

  inputFocus() {
    if (CheckDevice.isMobile()) {
      this.showFooter = false
    } else {
      this.showFooter = true
    }
  }

  inputBlur() {
    setTimeout(() => {
      this.showFooter = true
    }, 1)
  }

  sendMessage(normalizeData = true) {
    if (this.overLengthContent || this.includesScriptTagContent) return
    let msgInput = this.editorData
      ? this.editorData.replace(
          '<img',
          '<img class="mh--45 mw--45 mh-xl--100 mw-xl--100"'
        )
      : // : (this.$refs.inputMessageChat as any).innerHTML
        this.contentTextArea

    //remove text on UI
    this.contentTextArea = ''

    // remove br tag
    msgInput = msgInput.replace(/^(<br>)+|(<br>)+$/g, '')
    if (
      !this.editorData &&
      !removeHTML(msgInput).trim() &&
      this.lstFileUpload.length === 0
    ) {
      this.contentTextArea = ''
      return
    }
    let messageNew: MessageModel = new MessageModel()
    messageNew.content = msgInput
    if (this.currentUser.userId) {
      messageNew.senderId = this.currentUser.userId
    }

    if (this.groupItemSelected) {
      messageNew.groupChatId = this.groupItemSelected
    }
    messageNew.userName = this.currentUser.userName
    messageNew.userAvatar = this.currentUser.avatar
    messageNew.timeSent = new Date()
    // set message reply
    let msgReply = null
    if (this.isVisableReplyMessage && this.messageReply) {
      msgReply = this.messageReply.messageId
    }
    messageNew.messageSpecial = this.messageSpecial
    if (this.lstFileUpload.length > 0) {
      this.lstFileUpload.forEach((fileUpload: any) => {
        // file upload html
        let fileUploadHtml =
          '<div class="d-flex justify-content-between rouned align-items-center hover-file-upload bg-light w--80 mh--20 me-5 mt-2">' +
          '<div class="d-flex flex-row align-items-center">' +
          '<span class="far fa-file px-2 fs-34"></span>' +
          '<div class="d-flex flex-column">' +
          '<span>' +
          fileUpload.name +
          '</span>' +
          '<span>' +
          fileUpload.size +
          '</span>' +
          '</div></div>' +
          '<a href="' +
          fileUpload.url +
          '" download><span class="fal fa-file-download cursor-pointer btn-upload text-secondary-tint-less pe-2 opacity-0" /></a>' +
          '</div>'
        messageNew.content = messageNew.content + fileUploadHtml
      })
    }
    const sanitizeContent = sanitizeContentEditableInput(messageNew.content) 
    // set data
    let messageNewDb: any = {
      content: normalizeData ? sanitizeContent : messageNew.content,
      content_text: normalizeData ? stripHtmlKeepFormat(sanitizeContent) : stripHtmlKeepFormat(messageNew.content),
      sender_id: messageNew.senderId,
      group_chat_id: messageNew.groupChatId,
      user_name: messageNew.userName,
      user_avatar: messageNew.userAvatar,
      time_sent: messageNew.timeSent,
      is_deleted: '',
      is_like: '',
      message_special: this.messageSpecial,
      reply_message: msgReply,
      file_ids: this.fileIds
    }

    const mentionAllId = allItemMention.id.toString()
    const uniqueMentionsIds = getMentionIdsFromContent(messageNew.content)
    if (uniqueMentionsIds.length > 0) {
      messageNewDb.user_ids = uniqueMentionsIds.filter(id => id !== mentionAllId)
      if (uniqueMentionsIds.includes(mentionAllId)) {
        messageNewDb.mention_all = 'true'
      }
    }
    // send message
    // send api to BE and BE return message new
    MessageService.sendMessage(messageNewDb)
      .then((res: any) => {
        if (res.status === 200) {
            this.checkUserSendMessage = true
        }
      })
      .catch((err: any) => {
        if (
          err.response.status === 404 &&
          err.response.data.error === ERR_API_KEY.SEND_MESSAGE_DENIED
        ) {
          this.goToListGroupChat()
        }
      })
      .finally(() => {
        this.messageSpecial = false
      })
  }

  private async getInfoGroupChat() {
    if (this.groupItemSelected) {
      await GroupChatService.getGroupChatById(this.groupItemSelected)
        .then((res: any) => {
          if (res.status === 200) {
            if (res && res.data) {
              this.setInfoGroupChat(res.data)
            }
          }
        })
        .catch((err: any) => {
          if (err.response.status === 404) {
            this.modalMess = this.$t(
              'common.message.can_not_access_group_chat'
            ) as string
            this.modalAction = () => this.goToListGroupChat()
            this.$bvModal.show('modal-error-chat-detail')
          }
        })
    }
  }

  private async setInfoGroupChat(data: any) {
    let timeSent = ''
    if (data.updated_at) {
      if (
        moment(data.updated_at).format('DD/MM/YYYY') ===
        moment().format('DD/MM/YYYY')
      ) {
        timeSent = moment(data.updated_at).format('HH:mm')
      } else {
        timeSent = `${moment(data.updated_at).format('DD/MM')}（${moment(
          data.updated_at
        ).format('dddd')}）`
      }
    }
    // favorite group chat
    let favoriteGroupChat: boolean = false
    favoriteGroupChat = data.is_favorite

    this.isMultipleChatGroup = data?.user_group_chat?.length >= 2
    // set group chat name
    const name = this.handleSetGroupChatName(data)
    this.groupChatSelected = new GroupChatModel(
      data,
      name,
      favoriteGroupChat,
      timeSent
    )

    this.groupSelected = data.group

    //group chat name
    this.groupChatName = name

    //handle unread message
    this.unreadMeesageStartId = data.last_message_id
    this.getUnreadMeesageEndId()
  }

  private setUserLogin(user: any) {
    this.$set(this.currentUser, 'userId', user.info.id)
    this.$set(this.currentUser, 'userName', user.info.name)
    this.$set(this.currentUser, 'avatar', user.profile.avatar)
  }

  @Watch('contentTextArea')
  inputMessage() {
    const temp = document.createElement('div');
    temp.innerHTML = this.contentTextArea;
    const text = temp.innerText;

    this.overLengthContent =
      new Blob([text]).size > 80000 || _.toArray(text).length > 20000
    this.includesScriptTagContent = checkScript(text)
  }

  resetEditor() {
    this.editorData = ''
    this.messageSpecial = false
    this.listToSearchMentionWithBoxInModal = []
    this.onClearSuggestionState()

    const searchToMentionBoxInModalRef = this.$refs.searchToMentionBoxInModalRef as any
    if (searchToMentionBoxInModalRef) {
      searchToMentionBoxInModalRef.clearSearch()
    }
  }

  viewProfileUser(message: MessageModel) {
    if (message.userStatus === EUserStatus.NORMAL) {
      this.$bvModal.show('modal-user-in-chat-detail')
      this.userId = message.senderId
    }
  }

  async likeMessage(emojiId: string, msgId: number) {
    if (!msgId) return
    let msgChoose = this.lstMessageGroupChatDefault.find(
      (msg: any) => msg.messageId === msgId
    )
    const currentUserReact = msgChoose?.liker?.find((liker: any) => liker.id === this.$store.state.userInfo.user.info.id)
    // userLike: 0 = unlike, 1 = like (or override existing react with a new emoji / brand new like)
    const isUnlike = currentUserReact?.pivot?.emoji_id === emojiId
    const userLike = isUnlike ? 0 : 1

    let dataLike = {
      react_type: 1,
      like: userLike,
      emoji_id: emojiId
    }

    this.$blockui.show()

    // api
    try {
      await MessageService.reactMessage(msgId, dataLike)
    } catch (err) {
      console.log(err)
    } finally {
      this.$blockui.hide()
    }
  }

  getLikerEmoji(msg: MessageModel) {
    const userLiker = msg?.liker?.find(item => item.pivot.user_id === this.$store.state.userInfo.user.profile.user_id)
    return userLiker?.pivot?.emoji_id
  }

  addEmoji(emoji: any, messageId: number) {
    this.likeMessage(emoji.native, messageId)
  }

  replyMessage(msgId: any) {
    if (!msgId) {
      return
    }

    // set reply message
    this.messageReply = new MessageModel()
    this.isVisableReplyMessage = true
    let msgReply = this.lstMessageGroupChatDefault.find((msg: any) => {
      return msg.messageId === msgId
    })
    if (msgReply) {
      this.messageReply = msgReply
      ;(this.$refs.inputTextArea as any).focus()
    } else {
      return
    }
  }

  async findMessageInList(messageReply: any) {
    if (!messageReply.isDeletedByAuthor) {
      let el = document.getElementById(`message-${messageReply.messageId}`)
      await this.clickLoadMoreMessage()
      if (messageReply.currentPage === 1) {
        el || messageReply.messFound
          ? this.scrollToEl(messageReply)
          : this.scrollToBottom()
        return
      }
      if (el) {
        this.scrollToEl(messageReply)
      } else {
        await this.clickLoadMoreMessageDown()
        this.scrollToEl(messageReply)
      }
    }
  }

  async scrollToEl(messageReply: any) {
    await this.$nextTick()
    const el = document.getElementById(`message-${messageReply.messageId}`)
    if (!el) return

    requestAnimationFrame(() => {
      el.scrollIntoView({
        block: 'center',
      })
      this.blinkMessageId = Number(messageReply.messageId)
    })
    setTimeout(() => {
      this.blinkMessageId = -1
    }, 1000)
  }

  /**
   * Open delete message confirm
   */
  openModalConfirmDelMess(mess: any) {
    this.deleteMess = mess
    if (mess.isCanDelete && !mess.isOwnMsg) {
      this.deleteMessage(true)
    } else {
      this.$bvModal.show(`confirm-modal-delete-message`)
    }
  }

  /**
   * Open delete modal delete message success
   */
  messageDeleted(no: string) {
    this.infoMess = `No.${no} ${this.$t('common.message.deleted')}`
    this.$bvModal.show('modal-success-chat-detail')
  }

  /**
   * Delete message by id
   */
  async deleteMessage(noShowSuccessModal?: boolean) {
    const msgId = this.deleteMess.messageId
    if (!msgId) {
      return
    }
    let dataDelete = {
      react_type: 2
    }
    this.$blockui.show()

    try {
      await MessageService.reactMessage(msgId, dataDelete)
      if (!noShowSuccessModal) {
        this.messageDeleted(this.deleteMess.index)
      }
    } catch (err) {
        console.log(err)
    } finally {
      this.$blockui.hide()
    }
  }

  removeUploadFile(url: any) {
    if (!url) {
      return
    }
    this.lstFileUpload = this.lstFileUpload.filter((file: any) => {
      return file.url !== url
    })
  }

  async getUnreadMeesageEndId() {
    let dataSearch = {
      groupChatId: this.groupItemSelected,
      limit: 1,
      page: 1
    }
    return MessageService.getAllMessageInGroupChat(dataSearch).then(
      (res: any) => {
        if (res.status === 200) {
          this.unreadMeesageEndId = res.data?.data.data[0]?.id
        }
      }
    )
  }

  async getAllLstMessageInGroupChat() {
    let dataSearch = {
      groupChatId: this.groupItemSelected,
      limit: this.limitMessage,
      page: 1,
      messageSearchId: this.$route.query.message
        ? this.$route.query.message
        : ''
    }

    // this.screenLoading = !!!this.$route.query.message //if route have query message, set screenLoading to false

    return MessageService.getAllMessageInGroupChat(dataSearch)
      .then(async (res: any) => {
        if (res.status === 200) {

          let reachBottom = false

          if (document.body.clientWidth > 1200) {
            //check if user is scroll bottom
            let lstMsgScroll = this.$refs.lstMessageGroup as any
            reachBottom =  lstMsgScroll.scrollTop + lstMsgScroll.clientHeight === lstMsgScroll.scrollHeight
          } else {
            reachBottom = ((window.innerHeight + window.scrollY) >= document.body.offsetHeight);
          }

          //binding data
         const haveNewMessage = await this.setLstMessageInGroupChat(res.data.data)

         const hasQueryMessage = !!this.$route.query.message

        // if this call is because this user send message, scroll to bottom
        // if this call is call when scroll is at bottom, scroll to bottom to get newer message
        if (!hasQueryMessage) {
        setTimeout(() => {
        if(reachBottom || this.checkUserSendMessage) {
        this.scrollToBottom()
        this.checkUserSendMessage = false
        } else if(!this.showButtonScrollToBottom) {
        this.showButtonScrollToBottom = haveNewMessage
        }

        // if this is first time loading this page, scroll to bottom
        if(this.firstLoad) {
        this.scrollToBottom()
        this.showButtonScrollToBottom = false
        this.firstLoad = false
        }

        this.screenLoading = false
        }, 300)  
        }

        if (hasQueryMessage) {
          this.findMessagePage = res.data.data.current_page
          this.messFound = res.data.page_by_message_exist

          setTimeout(() => {
              this.findMessageInList({
                messageId: this.$route.query.message,
                currentPage: res.data.data.current_page,
                messFound: res.data.page_by_message_exist
              })
              this.$router.replace({ query: {} }).catch(() => {})
            }, 500)
          }
          if (!res.data.page_by_message_exist) {
            this.modalMess = this.$t(
              'common.message.message_not_found'
            ) as string
            this.$bvModal.show('find-message-not-found')
          }
          
          this.loadingLstMessage = false
        }
      })
      .catch((err: any) => {
        console.log(err)
        this.goToListGroupChat();
      })
  }

  async scrollToBottom(shouldScroll = true) {
    if (shouldScroll) {
      await this.$nextTick()
      if (document.body.clientWidth > 1200) {
        const lstMsgScroll = this.$refs.lstMessageGroup as any
        if (lstMsgScroll) {
          const h = lstMsgScroll.scrollHeight + 100
          lstMsgScroll.scrollTo({
            top: h,
            left: 0,
            behavior: 'smooth'
          })
        }
      } else {
        ;(this.$refs.inputTextArea as any)?.blur()

        requestAnimationFrame(() => {
          const h = document.body.scrollHeight + 100
          window.scrollTo({
            top: h,
            left: 0,
            behavior: 'smooth'
          })
        })
      }
    }
    this.isVisableReplyMessage = false
    this.showButtonScrollToBottom = false
    this.lstFileUpload = []
  }

  updateMessageInLists(messageId: string, callback: (item: any) => void) {
    const updateList = (list: any[]) => {
      const index = list.findIndex((m: any) => m.messageId === messageId)
      if (index !== -1) callback(list[index])
    }

    updateList(this.lstMessageGroupChat)
    updateList(this.lstMessageGroupChatDefault)
  }

  handleLikeOnRealtime(data: any) {
    const { messageId, userReactMessage = [] } = data || {}
    const isCurrentUserLike = userReactMessage?.some(
      (react: any) => react.id === this.currentUser.userId
    )

    this.updateMessageInLists(messageId, (item: any) => {
      this.$set(item, 'liker', Array.isArray(userReactMessage) ? userReactMessage : [])
      this.$set(item, 'isLike', isCurrentUserLike)
    })
  }

  handleDeleteOnRealtime(data: any) {
    const { deletedBy, messageId , infoMessage} = data || {}

    if (deletedBy) {
      if (this.currentUser.userId === deletedBy && deletedBy === infoMessage.sender_id) {
        this.lstMessageGroupChat = this.lstMessageGroupChat.filter(m => m.messageId !== messageId)
        this.lstMessageGroupChatDefault = this.lstMessageGroupChatDefault.filter(m => m.messageId !== messageId)
      } else {
        this.updateMessageInLists(messageId, (item: any) => {
          this.$set(item, 'content', 'chat_detail_message_deleted')
          this.$set(item, 'isCanDelete', true)
          this.$set(item, 'isOwnMsg', false)
        })
      }
    }
  }

  handleAppendNewMessage(data: any) {
    const { infoMessage, messageId } = data || {}
    const isIncludeInList = this.lstMessageGroupChat.some(m => m.messageId === messageId)

    if (!isIncludeInList) {
      const formatData =  mappingChatMessage(infoMessage, Number(this.currentUser.userId))
      this.lstMessageGroupChat = [...this.lstMessageGroupChat, formatData];
      this.lstMessageGroupChatDefault = [...this.lstMessageGroupChatDefault, formatData];

      this.showNoMessage = false

      // trigger right after message append to dom
      this.$nextTick(() => {
        let reachBottom = false

        if (document.body.clientWidth > 1200) {
          //check if user is scroll bottom
          let lstMsgScroll = this.$refs.lstMessageGroup as any
          reachBottom =  lstMsgScroll.scrollTop + lstMsgScroll.clientHeight === lstMsgScroll.scrollHeight
        } else {
          reachBottom = ((window.innerHeight + window.scrollY) >= document.body.offsetHeight);
        }

        if (reachBottom) {
          this.scrollToBottom()
        } else if (formatData.senderId === this.currentUser.userId) {
          this.scrollToBottom()
        } else {
          this.showButtonScrollToBottom = true
        }
      })
    }
  }

  handleRealtime() {
    let trackingRealtime = true
    const start = this.moment()
      .subtract(1, 'm')
      .toDate()
    this.unsubscribe = messagesRef
      .where('groupChatId', '==', this.groupItemSelected)
      .where('createdAt', '>', start)
      .onSnapshot(async (querySnapshot: any) => {
        if (trackingRealtime) {
          trackingRealtime = false
        } else {
          // check message updated
          querySnapshot.docChanges().forEach((messageChange: any) => {
            console.log('messagesRef: retrive doc data from firebase', messageChange.doc.data(), messageChange.type)
            if (messageChange.type === 'modified' || messageChange.type === 'added') {
              // handle like for other users
              const { delete: isDeleted } = messageChange.doc.data() || {}
              if (isDeleted) {
                this.handleDeleteOnRealtime(messageChange.doc.data())
              } else {
                this.handleAppendNewMessage(messageChange.doc.data())
                this.handleLikeOnRealtime(messageChange.doc.data())
                this.markReadGroupChat(true)
              }
            }
          })
        }
      })
  }

  handleReadRealtime() {
    let trackingRealtime = true
    this.readUnsubscribe = readGroupChatRef
      .where('groupChatId', '==', Number(this.groupItemSelected))
      .onSnapshot(async (querySnapshot: any) => {
        if (trackingRealtime) {
          trackingRealtime = false
          return
        }
        this.processReadSnapshotChanges(querySnapshot)
      })
  }

  private processReadSnapshotChanges(querySnapshot: any) {
    querySnapshot.docChanges().forEach((messageChange: any) => {
      console.log('readGroupChatRef: retrive doc data from firebase', messageChange.doc.data(), messageChange.type)
      if (
        messageChange.type === 'modified' ||
        messageChange.type === 'added'
      ) {
        this.handleReadMessageChange(messageChange.doc.data())
      }
    })
  }

  private handleReadMessageChange(data: any) {
    const { infoUserReadMsg, messageId } = data || {}
    this.updateMessageInLists(messageId, (message: any) => {
      this.markMessageAsReadByUser(message, infoUserReadMsg)
    })
  }

  private markMessageAsReadByUser(message: any, infoUserReadMsg: any) {
    const isIncludeInMessageRead = message?.usersRead?.some(
      (user: any) => user.id === infoUserReadMsg.id
    )

    if (!isIncludeInMessageRead) {
      const updatedUsersRead = [
        ...(message.usersRead || []),
        infoUserReadMsg
      ]
      this.$set(message, 'usersRead', updatedUsersRead)
    }
  }

  private async fetchMessagesByGroupChatId() {
    if (this.groupChatSelected.groupChatId) {
      const dataSearch = {
        groupChatId: this.groupChatSelected.groupChatId,
        limit: this.limitMessage,
        page: this.page
      }
      return MessageService.getAllMessageInGroupChat(dataSearch)
        .then((res: any) => {
          if (res.status === 200) {
            if (res && res.data) {
              this.setLstMessageInGroupChat(res.data.data)
            }
          }
        })
        .catch((err: any) => {
          console.log(err)
        })
    }
  }

  private async setLstMessageInGroupChat(data: any): Promise<boolean> {
    if (data.data.length > 0) {
      let allMessagesRead = data.data.map((msg: any) =>
        mappingChatMessage(msg, Number(this.currentUser.userId))
      )

      this.lastPage = data.last_page

      if (this.$route.query.message) {
        this.page = data.current_page
        this.pageUp = data.current_page
        this.pageDown = data.current_page
        this.searchPage = data.current_page
        this.disablePageUp = this.page === this.lastPage
        this.disablePageDown = this.page === 1
        this.loadMoreDown = data.current_page !== 1
      }

      // Build a set of messageIds returned by the API (this page)
      const incomingIds = new Set(allMessagesRead.map((msg: any) => msg.messageId))

      // Keep messages from OTHER pages, replace all messages from this page with fresh API data
      const merged = [
        ...this.lstMessageGroupChatDefault.filter(
          (msg: any) => !incomingIds.has(msg.messageId)
        ),
        ...allMessagesRead
      ]

      const hasNewOrChanged = allMessagesRead.some((msg: any) => {
        const existing = this.lstMessageGroupChatDefault.find(
          (d: any) => d.messageId === msg.messageId
        )
        return !existing
      })

      //sort by message id
      this.lstMessageGroupChatDefault = _.sortBy(merged, 'messageId')
      this.lstMessageGroupChat = this.lstMessageGroupChatDefault

      this.showNoMessage = this.lstMessageGroupChat.length === 0
      return hasNewOrChanged

    } else if (data.data.length === 0) {
      this.lstMessageGroupChat = []
    }

    this.showNoMessage = this.lstMessageGroupChat.length === 0
    return false
  }

  hanldeUserStatus(name: string, status: EUserStatus) {
    if (status === EUserStatus.LEAVE_GROUP_TAG)
      return (
        name +
        this.$t('common.suffix.san') +
        this.$t('common.suffix.leave_group')
      )
    if (status === EUserStatus.LEAVE_SYSTEM)
      return this.$t('common.suffix.leave_system') as string
    return name + this.$t('common.suffix.san')
  }

  handleGroupNameLeave(name: string, status: EUserStatus) {
    if (status === EUserStatus.LEAVE_GROUP_TAG)
      return name + this.$t('common.suffix.leave_group')
    if (status === EUserStatus.LEAVE_SYSTEM)
      return this.$t('common.suffix.leave_system') as string
    return name
  }

  openModalGallery() {
    this.openGallery = true
  }

  closeModalGallery() {
    this.openGallery = false
  }

  openFullImage(src: string) {
    this.fullOverviewSrc = src
    this.canOpenFullImageModal = true
  }

  onChatInlineEditorImageClick(e: MouseEvent) {
    const root = e.currentTarget as HTMLElement
    const src = getInlineEditorImageSrcFromClick(e, root)
    if (!src) return
    e.preventDefault()
    e.stopPropagation()
    this.openFullImage(src)
  }

  inviteUser() {
    this.showModalManageMember = true
  }

  goToListGroupChat() {
    if (this.$route.params.from) {
      this.$router.push(this.$route.params.from)
    } else {
      this.$router.push({ name: 'chat-list' })
    }
  }

  goToListGroupChatRoute() {
    if (this.$route.params.from) {
      return (this.$route.params.from)
    } else {
      return ({ name: 'chat-list' })
    }
  }

  async outGroupChat() {
    await this.fetchUserInGroupChat()
    if (this.lstUserGroupChat.length === 1) {
      this.confirmLeaveChatMess = this.$t('common.message.confirm_last_leave_chat') as string
    } else {
      this.confirmLeaveChatMess = this.$t('common.message.confirm_leave_chat') as string
    }
    this.$bvModal.show('confirm-leave-chat-list')
  }

  async favoriteGroupChat() {
    this.$blockui.show()
    let groupChatId = this.groupChatSelected.groupChatId
    await GroupChatService.toggleFavouriteGroupChat(groupChatId)
      .then((res: any) => {
        if (res.status === 200) {
          this.groupChatSelected.favorite = !this.groupChatSelected.favorite
          triggerFavorite()
        }
      })
      .catch((err: any) => {
        console.log(err)
      })
      .finally(() => this.$blockui.hide(false))
  }

  async clickLoadMoreMessage() {
    if (this.disablePageUp) return

    if (this.screenLoading) {
      this.screenLoading = false
      return
    }

    //if last loadmore is page down -> set current page to last page up
    if (this.isPageDown) this.page = this.pageUp

    //set loadmore to page up
    this.isPageUp = true

    //re-count page
    ++this.page

    //if current page is search page (search page is have data loaded at screen start), continues re-count
    if (this.page === this.searchPage) ++this.page

    //set last page up = this current page
    this.pageUp = this.page

    //if page is max (= lastPage) disable page up forever
    this.disablePageUp = this.page === this.lastPage

    //call API to get data and scroll to last - old message
    let lstMsgScroll = this.$refs.lstMessageGroup as any
    const oldBodyHiehgt = document.body.scrollHeight
    const oldListMessHiehgt = lstMsgScroll.scrollHeight
    await this.fetchMessagesByGroupChatId()
    if (document.body.clientWidth > 1200) {
      const h = lstMsgScroll.scrollHeight - oldListMessHiehgt
      lstMsgScroll.scrollTo(0, h)
    } else {
      const h = document.body.scrollHeight - oldBodyHiehgt
      window.scrollTo(0, h)
    }

    if (this.$route.query.message) {
        await this.$nextTick()

        await this.findMessageInList({
          messageId: this.$route.query.message,
          currentPage: this.findMessagePage,
          messFound:  this.messFound
        })
        
        this.$router.replace({ query: {} }).catch(() => {})
      }
  }

  async clickLoadMoreMessageDown() {
    if (this.disablePageDown) return

    //if last loadmore is page up -> set current page to last page down
    if (this.isPageUp) this.page = this.pageDown

    //set loadmore to page down
    this.isPageDown = true

    //re-count page
    --this.page

    //if current page is search page (search page is have data loaded at screen start), continues re-count
    if (this.page === this.searchPage) --this.page

    //set last page down = this current page
    this.pageDown = this.page

    //if page is min (= 1) disable page up forever
    this.disablePageDown = this.page === 1
    //call API to get data
    await this.fetchMessagesByGroupChatId()
  }

  downloadGalleyExist(msg: any) {
    const mappingIds = msg?.file?.map((file: any) => file?.id)
    let fileIds = {
      file_ids: mappingIds
    }

    //handle dowload IOS not safari
    if (
      CheckDevice.iOSBrowerName().toLowerCase() !== CheckDevice.safari &&
      CheckDevice.isMobile() &&
      CheckDevice.getMobileOS() === CheckDevice.ios
    ) {
      msg?.file?.forEach((file: any) => window.open(file?.path))
      return
    }

    // 画面全体はブロックせず、右下に進捗とキャンセルを出す。失敗時の文言も runDownload が出す（NWS_SMILELINE-1936）
    runDownload(
      downloadLabel(msg.file.map((file: any) => file?.file_name)),
      config => GroupChatService.downloadGallery(fileIds, config),
      { key: `group-chat-gallery:${mappingIds.join(',')}` }
    ).then(res => {
      if (res && res.status === 200) {
        if (mappingIds.length === 1) {
          let fileName = msg.file[0].file_name
          this.hanldeDownloadFile(res, fileName)
        } else {
          this.hanldeDownloadMultipleFiles(res)
        }
      }
    })
  }

  hanldeDownloadMultipleFiles(res: any) {
    const blob = new Blob([res.data], { type: 'application/zip' })
    const link = document.createElement('a')
    const url = globalThis.URL.createObjectURL(blob)
    link.href = url
    link.download = 'download.zip'
    link.click()
    revokeObjectUrlLater(url)
  }

   hanldeDownloadFile(res: any, fileName: string) {
    const bytes = new Uint8Array(res.data)
    const blob = new Blob([bytes], { type: '*' })
    let a = document.createElement('a')
    const url = globalThis.URL.createObjectURL(blob)
    a.href = url
    a.setAttribute('download', fileName)
    a.click()
    revokeObjectUrlLater(url)
  }

  handleSetGroupChatName(group: any) {
    if (!group.only_user && !group.onlyUser) {
      return group.name ? group.name : group.gCName
    }

    if (!group.only_user && !group.onlyUser && !group.user_group_chat.length) {
      return group.name ? group.name : group.gCName
    }

    let groupChatName = group.user_group_chat

    if ((group.only_user || group.onlyUser) && group.user_leave_chat) {
      groupChatName = [
        {
          name: this.handleGroupNameLeave(
            group.user_leave_chat.name,
            group.user_leave_chat.leaveType
          )
        }
      ]
    }

    if (!groupChatName) return
    let groupName =
      (groupChatName.length > 2 ? groupChatName.slice(0, 2) : groupChatName)
        .map((item: any) => item.name)
        .join(`${this.$t('common.suffix.san')}${this.$t('chat.comma')}`) +
      this.$t('common.suffix.san')
    let otherUserCount = groupChatName.length > 2 ? groupChatName.length - 2 : 0
    let groupNameFull =
      String(groupName) +
      (otherUserCount > 0
        ? this.$t('chat.chat_group_name_with', {
            other_user_count: otherUserCount
          })
        : '') +
      this.$t('chat.chat_with')
    return groupNameFull
  }

  /**
   * Mark read group when focus input chat
   */
  async markReadGroupChat(handleForMention = false) {
    let data: any = {
      group_chat_id: this.idGroupChat,
      count_message_not_seen: 0
    }

    const response = await ChatService.markReadGroupChat(data)

    if (response.status === 200) {
      //handle rebind unred count
      CommonTopicModule.SET_RELOAD_UNREAD(true)

      if (!handleForMention) {
        await ChatService.markReadChatMention({
          group_chat_id: this.idGroupChat,
        })
      }
    }
  }

  /**
   * Open modal list liker modal
   */
  openUserListModal(list: any[], showEmoji = false) {
    this.userListModalShowEmoji = showEmoji
    this.userListModal = list?.map(item => {
      return {
        id: item.user_active_status ? -1 : item.id,
        avatar:
          item.user_active_status === EUserStatus.LEAVE_SYSTEM
            ? ''
            : item.user_profile?.avatar || item.avatar,
        liker_name: item.name,
        user_active_status: item.user_active_status,
        emoji_id: showEmoji ? item?.pivot?.emoji_id || '' : undefined
      }
    })
    this.$nextTick(() => {
      this.$bvModal.show('user-list-modal')
    })
  }

  handleChatContent(chatContent: string) {
    if (!chatContent) return ''
    const text = chatContent.split(',')[0]
    switch (text) {
      case this.LEAVE_GROUP_CHAT:
        return this.$t('chat.list.msg.leave_group_chat', {
          name: chatContent.split(',')[1]
        })
      case this.LEAVE_SYSTEM:
        return this.$t('chat.list.msg.leave_system', {
          name: chatContent.split(',')[1]
        })
      default:
        return linkifyHtml(chatContent || '', { target: "_blank" });
    }
  }

  getFormatIconClass(extension: string) {
    return CheckFileFormat.getIconClassNameWithFileExtention(extension)
  }

  getFileFormat(extension: string) {
    return CheckFileFormat.getFileFormat(extension)
  }

  handleLongText(text: string, max?: number) {
    return PreviewText.covertToPreviewText(text, max)
  }

  async leaveGroupChat() {
    const groupChatId = this.$route.params.groupChatId
    this.$blockui.show()
    await GroupChatService.leaveGroupChat({
      group_chat_id: groupChatId
    })
      .then(res => {
        if (res.status === 200) {
          this.$router.push({
            name: 'chat-list'
          })

          this.$bvModal.show('modal-success-leave-chat')
        }
      })
      .catch(err => console.log(err))
    this.$blockui.hide(false)
  }

  async onTranslateMessage(index: number) {
    const item = this.lstMessageGroupChat[index]

    if (this.isDisabledTranslate(item)) {
      return
    }


    if (item.isTranslated) {
      item.isTranslated = false
      return
    }

    if (item.content_translation) {
      item.isTranslated = true
      return
    }

    const rawHtml = linkifyHtml(item.content || '', { target: '_blank' })
    const { doc, textNodes } = extractContentFromContentEditableOrTiny(rawHtml)
    const q = textNodes.map(t => t.originalText)

    if (!q.length) return

    await handleTranslation({
      modalId: 'chat-detail-translation-error-modal',
      q,
      onSuccess: async (res: any) => {
        const translations: string[] =
          res?.map((t: any) => decodeHtml(t.translatedText)) || []

        for (const item of textNodes) {
          const translated = translations.shift() || ''
          const indentHtml = item.indent.replaceAll(' ', '&nbsp;')

          const parent = item.node.parentNode as HTMLElement
          const span = document.createElement('span')
          span.innerHTML = indentHtml + escapeHtml(translated)

          parent.replaceChild(span, item.node)
        }

        item.isTranslated = true
        item.content_translation = doc.body.innerHTML
        this.lstMessageGroupChatDefault[index].isTranslated = true
        this.lstMessageGroupChatDefault[index].content_translation =
          doc.body.innerHTML

        return {
          target_id: item.messageId,
          type: TRANSLATION_TYPE.CHAT,
          content_translation: doc.body.innerHTML,
          group_chat_id: Number(this.$route.params.groupChatId)
        }
      },
      onError: (message: string) => {
        this.errorMess = message
      },
    })
  }

  onContentEditableInput() {
    if (this.atInstance && this.isMultipleChatGroup) {
      const editorEl = this.atInstance.$el.querySelector(
        '.mention-contenteditable'
      )
      if (editorEl) {
        const caretText = getCaretTextBefore(editorEl)
        const match = caretText.match(mentionRegex)
        if (match) {
          const query = match[1]
          this.atInstance.$emit('at', query)
        }
      }
    }
  }

  onContentEditableFocusOut() {
    this.failKeyword = ''
    this.savedRange = getRange()
  }

  onContentEditableFocusIn() {
    this.$nextTick(() => {
      if (this.atInstance && this.isMultipleChatGroup) {
        const editorEl = this.atInstance.$el.querySelector('.mention-contenteditable')
        if (editorEl) {
          requestAnimationFrame(() => {
            const caretText = getCaretTextBefore(editorEl)
            const match = caretText.match(mentionRegex)
            if (match) {
              this.atInstance.$emit('at', match[1])
            }
          })
        }
      }
    })
  }

  async handleSearchMention({
    keyword,
    listTarget,
    closeDropdownFn,
    shouldHandleLoading
  }: {
    keyword: string
    listTarget: any[]
    closeDropdownFn?: () => void
    shouldHandleLoading?: boolean
  }) {
    const result = await this.fetchMentionByGroupChatApi({
      keyword,
      shouldHandleLoading
    })

    if (
      result.length > 0 ||
      allMentionCheckKeyword.includes(keyword.toLowerCase()) ||
      !keyword
    ) {
      const newList: Mentionable[] = []

      if (allMentionCheckKeyword.includes(keyword.toLowerCase()) || !keyword) {
        newList.push(allItemMention)
      }

      if (result.length > 0) {
        newList.push(...result)
      }

      listTarget.splice(0, listTarget.length, ...newList)
    }

    if (
      result.length === 0 &&
      !allMentionCheckKeyword.includes(keyword.toLowerCase()) &&
      keyword
    ) {
      closeDropdownFn?.()
      this.onClearListWithDelay(listTarget)
    }
  }

  async onSearchMentionWithBox(keyword: string) {

    await this.handleSearchMention({
      keyword,
      listTarget: this.listToSearchMentionWithBox,
      shouldHandleLoading: true
    })
  }

  async onSearchMentionWithBoxInModal(keyword: string) {

    await this.handleSearchMention({
      keyword,
      listTarget: this.listToSearchMentionWithBoxInModal,
      shouldHandleLoading: true
    })
  }

  onClearListWithDelay(listTarget: Mentionable[]) {
    setTimeout(() => {
      listTarget.splice(0, listTarget.length)
    }, 200)
  }

  onSelectMention(item: Mentionable) {
    const mentionHtml = `<span class="mention" translate="no" data-id=${item.id} style="color: #007bff; font-weight: bold;">@${item.name}</span>`
   
    const editorEl = this.atInstance.$el.querySelector(
        '.mention-contenteditable'
      )
      if (editorEl) {
        const range = ensureRange(editorEl, this.savedRange)
        this.savedRange = insertMention(range, mentionHtml)
        this.contentTextArea = editorEl.innerHTML
      }

    const searchToMentionBoxRef = this.$refs.searchToMentionBoxRef as any
    if (searchToMentionBoxRef) {
      searchToMentionBoxRef.closeDropdown()
    }
  }

  onSelectMentionInModal(item: Mentionable) {
    handleSelectSuggestion({
      suggestion: item,
      editorInstance: this.editorInstance,
      insertFromOutside: true
    })

    const searchToMentionBoxRef = this.$refs.searchToMentionBoxRef as any
    if (searchToMentionBoxRef) {
      searchToMentionBoxRef.closeDropdown()
    }
  }

  onContentEditableKeyUp(e: any) {
    // handle caret by mark a space on previous line when enter
    if (e.key === 'Enter') {
      const editorEl = this.atInstance.$el.querySelector(
        '.mention-contenteditable'
      )
      const newDiv = editorEl.lastElementChild as HTMLElement
      const prevDiv = newDiv?.previousElementSibling as HTMLElement

      if (prevDiv && prevDiv.tagName === 'DIV') {
        prevDiv.appendChild(document.createTextNode(' '))
      }

      if (prevDiv && prevDiv.tagName === 'SPAN') {
        const textNode = document.createTextNode(' ')
        prevDiv.parentNode?.insertBefore(textNode, prevDiv.nextSibling)
      }
    }
  }

  getEmojiByNative(nativeChar: string) {
    return getEmojiByNativeFunc(nativeChar, this.emojiIndex)
  }

  getDisplayMessageLikers(msg: any) {
    return (msg?.liker || []).slice(0, this.maxUserDisplay)
  }

  getMessageLikerRemainCount(msg: any) {
    const total = (msg?.liker || []).length
    return Math.max(total - this.maxUserDisplay, 0)
  }

  async getUserInGroupChat() {
    return await GroupChatService.getMemberGroupChatList({
      groupChatId: this.$route.params.groupChatId,
      page: 1,
      limit: 9999,
    });
  }

  async fetchUserInGroupChat() {
    try {
      const res = await this.getUserInGroupChat()

      this.lstUserGroupChat = (res?.data?.data ?? []).map((user: any) => user.id)

    } catch (error) {
      console.error(error)
    }
  }
}
